import { useEffect, useState } from "react";
import API from "@/lib/api";

// Module-level cache so multiple components share lookups within one session.
const cache = new Map();

export default function useAvatarsByEmail(emails) {
  const [map, setMap] = useState({});

  useEffect(() => {
    const unique = Array.from(new Set((emails || []).filter(Boolean)));
    if (!unique.length) { setMap({}); return; }

    // Seed from cache first
    const seeded = {};
    const missing = [];
    for (const e of unique) {
      if (cache.has(e)) seeded[e] = cache.get(e);
      else missing.push(e);
    }
    if (Object.keys(seeded).length) setMap(prev => ({ ...prev, ...seeded }));

    if (!missing.length) return;

    let cancelled = false;
    API.post("/users/avatars-by-email", { emails: missing })
      .then(({ data }) => {
        if (cancelled) return;
        for (const e of missing) cache.set(e, data?.[e] ?? null);
        setMap(prev => ({ ...prev, ...data }));
      })
      .catch(() => {
        for (const e of missing) cache.set(e, null);
      });
    return () => { cancelled = true; };
    // Stringify to avoid re-firing on identical arrays
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify((emails || []).slice().sort())]);

  return map;
}
